document.addEventListener("DOMContentLoaded", () => {
  // Check if the current URL path includes "/en-us"
  if (window.location.pathname.includes("/en-us")) {
    // Define the replacements. Keys are the words to find, values are their replacements.
    // Add more entries as needed.
    const replacements = {
      Multicoloured: "Multicolored",
      colour: "color",
      catalogues: "catalogs",
      analogue: "analog",
      centre: "center",
      favourite: "favorite",
      licence: "license",
      organise: "organize",
      practise: "practice",
      recognise: "recognize",
      theatre: "theater",
      travelling: "traveling",
      dialogue: "dialog",
      endeavour: "endeavor",
      flavour: "flavor",
      honour: "honor",
      labour: "labor",
      neighbour: "neighbor",
      savour: "savor",
      splendour: "splendor",
      valour: "valour",
      apologise: "apologize",
      authorise: "authorize",
      capitalise: "capitalize",
      criticise: "criticize",
      emphasise: "emphasize",
      finalise: "finalize",
      initialise: "initialize",
      maximise: "maximize",
      minimise: "minimize",
      optimise: "optimize",
      realise: "realize",
      standardise: "standardize",
      summarise: "summarize",
      utilise: "utilize",
      defence: "defense",
      offence: "offense",
      pretence: "pretense",
      licence: "license",
      practice: "practise", // Note: 'practice' (noun) vs 'practise' (verb) in British English. This replaces the verb form.
      programme: "program",
      cheque: "check",
      storey: "story",
      tyre: "tire",
      aeroplane: "airplane",
      aluminium: "aluminum",
      analyse: "analyze",
      artefact: "artifact",
      cosy: "cozy",
      enrol: "enroll",
      instalment: "installment",
      jewellery: "jewelry",
      judgement: "judgment",
      manoeuvre: "maneuver",
      mould: "mold",
      "mustn't": "must not",
      "oughtn't": "ought not",
      "shouldn't": "should not",
      "wouldn't": "would not",
      "can't": "cannot",
      "won't": "will not",
      "don't": "do not",
      "isn't": "is not",
      "aren't": "are not",
      "wasn't": "was not",
      "weren't": "were not",
      "hasn't": "has not",
      "haven't": "have not",
      "hadn't": "had not",
      "couldn't": "could not",
      "mightn't": "might not",
      "needn't": "need not",
      "daren't": "dare not",
      "shan't": "shall not",
      gonna: "going to",
      wanna: "want to",
      gotta: "got to",
      lemme: "let me",
      gimme: "give me",
      kinda: "kind of",
      sorta: "sort of",
      "ain't": "am not", // or is not, are not, has not, have not
      "y'all": "you all",
      "y'all'd": "you all would",
      "y'all're": "you all are",
      "y'all've": "you all have",
      "y'all'll": "you all will",
      "y'all'd've": "you all would have",
      "y'all'd'nt": "you all would not",
      "y'all'd'nt've": "you all would not have",
      "y'all'll've": "you all will have",
      "y'all're've": "you all are have",
      "y'all've'nt": "you all have not",
      "y'all've'nt'll": "you all have not will",
      "y'all've'nt're": "you all have not are",
      "y'all've'nt'd": "you all have not would",
      "y'all've'nt'd've": "you all would have",
      "y'all've'nt'll've": "you all will have",
      "y'all've'nt're've": "you all are have",
      "y'all've'nt'd'nt": "you all have not would not",
      "y'all've'nt'd'nt've": "you all have not would not have",
      "y'all've'nt'll'nt": "you all have not will not",
      "y'all've'nt'll'nt've": "you all have not will not have",
      "y'all've'nt're'nt": "you all have not are not",
      "y'all've'nt're'nt've": "you all have not are not have",
      "y'all've'nt'd'nt'll": "you all have not would not will",
      "y'all've'nt'd'nt're": "you all have not would not are",
      "y'all've'nt'd'nt'll've": "you all have not would not will have",
      "y'all've'nt'd'nt're've": "you all have not would not are have",
      "y'all've'nt'd'nt'll'nt": "you all have not would not will not",
      "y'all've'nt'd'nt'll'nt've": "you all have not would not will not have",
      "y'all've'nt're'nt'd": "you all have not are not would",
      "y'all've'nt're'nt'll": "you all have not are not will",
      "y'all've'nt're'nt'd've": "you all have not are not would have",
      "y'all've'nt're'nt'll've": "you all have not are not will have",
      "y'all've'nt're'nt'd'nt": "you all have not are not would not",
      "y'all've'nt're'nt'd'nt've": "you all have not are not would not have",
      "y'all've'nt're'nt'll'nt": "you all have not are not will not",
      "y'all've'nt're'nt'll'nt've": "you all have not are not will not have",
    }

    // Sort the original words by length in descending order.
    // This ensures that longer words (e.g., "Multicoloured") are processed before
    // shorter words that might be substrings (e.g., "colour").
    const sortedOriginals = Object.keys(replacements).sort((a, b) => b.length - a.length)

    /**
     * Recursively traverses the DOM and replaces text within text nodes.
     * @param {Node} node The current DOM node to process.
     */
    function applyReplacements(node) {
      // Process only text nodes
      if (node.nodeType === Node.TEXT_NODE) {
        let text = node.nodeValue
        for (const original of sortedOriginals) {
          const replacement = replacements[original]
          // Create a global, case-insensitive regular expression for the original word
          const regex = new RegExp(`\\b${original}\\b`, "gi") // Use word boundaries (\b) for whole word matching

          text = text.replace(regex, (match) => {
            // Simple logic to preserve case:
            // If the matched word is all lowercase, return the replacement in lowercase.
            if (match === original.toLowerCase()) {
              return replacement.toLowerCase()
            }
            // If the matched word is all uppercase, return the replacement in uppercase.
            else if (match === original.toUpperCase()) {
              return replacement.toUpperCase()
            }
            // If the matched word is Title Case (first letter uppercase, rest lowercase),
            // return the replacement in Title Case.
            else if (
              match.charAt(0) === original.charAt(0).toUpperCase() &&
              match.slice(1) === original.slice(1).toLowerCase()
            ) {
              return replacement.charAt(0).toUpperCase() + replacement.slice(1).toLowerCase()
            }
            // For any other mixed case or if no specific case pattern matches,
            // return the replacement as defined in the `replacements` object.
            return replacement
          })
        }
        node.nodeValue = text // Update the text node with the replaced text
      }
      // Traverse child nodes, but skip script, style, and noscript tags to avoid breaking functionality
      else if (
        node.nodeType === Node.ELEMENT_NODE &&
        node.tagName !== "SCRIPT" &&
        node.tagName !== "STYLE" &&
        node.tagName !== "NOSCRIPT"
      ) {
        for (let i = 0; i < node.childNodes.length; i++) {
          applyReplacements(node.childNodes[i])
        }
      }
    }

    // Start applying replacements from the document body
    applyReplacements(document.body)
  }
})
